// extracted by mini-css-extract-plugin
export default {"layout":"BaseLayout_layout__1KT6o","content":"BaseLayout_content__F1QJC"};